import { useDispatch, useSelector } from "react-redux";
import { axiosInstance, handleErrors } from "../auth";
import { saveAs } from "file-saver";
import updateFieldForObjects from "utils/updateFieldForObjects";
// action config
const keyType = "list";
const perpage = 15;

export const UPDATE_FIELD = `${keyType}UpdateField`;
export const SET_LIST = `${keyType}SetList`;
export const CLEAR = `${keyType}Clear`;

export const updateFields = ({ prop, value }) => ({
  type: UPDATE_FIELD,
  payload: { prop, value },
});

export const useList = () => {
  const list = useSelector((state) => state.list);
  const dispatch = useDispatch();
  return {
    ...list,
    dispatch,
    clear,
    getList,
    listSearch,
    listFilter,
    create,
    remove,
    getSingle,
    update,
    restore,
    forceDelete,
    syncDelete,
    syncAdd,
    syncEdit,
    customRequest,
    dowloadFile,
    quickUpdate,
    createAndDownload,
    dowloadEexelReport,
    getDataList,
    getSingleNew,
  };
};

export const clear = () => ({
  type: CLEAR,
});

const searchFields = (key) => {
  // eslint-disable-next-line default-case
  switch (key) {
    case "news":
      return "translations.title,translations.slug";

    case "video":
      return "translations.title,translations.slug";

    case "league":
      return "translations.name,translations.slug,translations.shortName";

    case "team":
      return "translations.name,translations.slug";

    case "transfer":
      return "player.translations.slug,player.translations.name,player.translations.lastName";

    case "match":
      return "translations.name,translations.slug,homeTeam.translations.name,awayTeam.translations.name";

    case "stadium":
      return "translations.name,translations.slug";

    case "statistic":
      return "league.translations.name,team.translations.name,player.translations.name,match.translations.name";

    case "player":
      return "translations.name,translations.lastName";

    case "staff":
      return "translations.name,translations.lastName";

    case "referee":
      return "translations.name,translations.lastName";

    case "coach":
      return "translations.name,translations.lastName";

    case "user":
      return "translations.name,translations.lastName";

    case "category":
      return "translations.title,translations.slug";

    case "tag":
      return "translations.title,translations.slug";

    case "leagueNew":
      return "translations.name";
    case "teamNew":
      return "translations.name";
    case "matchNew":
      return "translations.name";
  }
};

const appendQueryParam = (url, key, value) => {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(
    String(value)
  )}`;
};

export const getList = (path, _page, _perPage) => async (
  dispatch,
  getState
) => {
  try {
    const {
      list: { page, perPage, searchKey, filters },
    } = getState();

    const currentPage = _page || page;
    const currentPerPage = Number(_perPage) || 15;

    dispatch(updateFields({ prop: "load", value: true }));

    if (path.endPath) {
      path.baseRoute = path.baseRoute + "?" + path.endPath;
    }

    let url = `${path.baseRoute}${
      path.baseRoute.includes("?") ? "&" : "?"
    }page=${currentPage}&perpage=${currentPerPage}`;

    if (searchKey) {
      const match = url.match(/\/([^/-]+)(?:-panel)?/);
      const extractedValue = match ? match[1] : null;

      url = appendQueryParam(
        appendQueryParam(url, "search.fields", searchFields(extractedValue)),
        "search.value",
        searchKey
      );
    } else {
      url = `${path.baseRoute}${
        path.baseRoute.includes("?") ? "&" : "?"
      }page=${currentPage}&perpage=${currentPerPage}`;
    }

    if (filters) {
      Object.keys(filters).forEach((item) => {
        if (filters[item]) {
          url = appendQueryParam(url, item, filters[item]);
        }
      });
    }

    const {
      data: {
        data,
        meta: {
          pagination: { last_page, total, per_page, current_page, from, to },
        },
      },
    } = await axiosInstance.get(url);

    dispatch({
      type: SET_LIST,
      payload: {
        list: data,
        page: current_page,
        lastPage: last_page,
        perPage: per_page,
        total,
        from,
        to,
        type: path.type,
      },
    });

    dispatch(updateFields({ prop: "perPage", value: per_page }));
    dispatch(updateFields({ prop: "load", value: false }));
  } catch (e) {
    handleErrors(e);
    console.log(e);
  }
};

export const getSingleNew = (path, id) => async (dispatch) => {
  try {
    dispatch(updateFields({ prop: "single", value: null }));
    dispatch(updateFields({ prop: "load", value: true }));

    const response = await axiosInstance.get(
      `${path.baseRoute}/${encodeURIComponent(id)}`
    );

    dispatch(updateFields({ prop: "single", value: response.data }));
    dispatch(updateFields({ prop: "type", value: path.type }));
  } catch (error) {
    handleErrors(error);
  } finally {
    dispatch(updateFields({ prop: "load", value: false }));
  }
};

export const getDataList = (path, _page, _perPage) => async (
  dispath,
  getState
) => {
  try {
    const {
      list: { page, perPage, searchKey, filters },
    } = getState();
    dispath(updateFields({ prop: "list", value: null }));
    dispath(updateFields({ prop: "load", value: true }));

    if (path.endPath) {
      path.baseRoute = path.baseRoute + "?" + path.endPath;
    }

    let url = `${path.baseRoute}${
      path.baseRoute.includes("?") ? "&" : "?"
    }page=${_page || page}&perpage=${_perPage || perPage}&search=${searchKey}`;

    const { data } = await axiosInstance.get(url);

    dispath({
      type: SET_LIST,
      payload: {
        list: data,
        page: 1,
        lastPage: 1,
        perPage: 1,
        total: data.length,
        from: 1,
        to: data.length,
        meta: null,
        type: path.type,
      },
    });
    dispath(updateFields({ prop: "load", value: false }));
  } catch (e) {
    handleErrors(e);
    console.log(e);
  }
};

export const listSearch = (path, searchKey) => async (dispath) => {
  dispath(updateFields({ prop: "searchKey", value: searchKey }));
  dispath(getList(path, 1));
};

export const listFilter = (path, filters) => async (dispath) => {
  dispath(updateFields({ prop: "filters", value: filters }));
  dispath(getList(path, 1));
};

export const customRequest = (
  method = "get",
  url,
  data,
  cb,
  loading = true
) => async (dispath) => {
  try {
    if (loading) {
      dispath(updateFields({ prop: "load", value: true }));
    }

    const result = await axiosInstance({
      method,
      url,
      data,
    });
    dispath(updateFields({ prop: "load", value: false }));
    cb(result.data);
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));

    handleErrors(e);
  }
};
export const create = (path, data, cb) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));

    let achievements, socials, metaData;
    if (data?.achievements) {
      achievements = data?.achievements;
      delete data?.achievements;
    }

    if (data?.socials) {
      socials = data?.socials;
      delete data?.socials;
    }
    if (data?.metaData) {
      metaData = data?.metaData;
      delete data?.metaData;
    }

    const add = await axiosInstance.post(path.baseRoute, data);

    if (add && add?.data?.data) {
      if (achievements?.length) {
        achievements = updateFieldForObjects(
          achievements,
          "entity",
          add?.data?.data?.id
        );
        achievements?.map(async (achievement) => {
          await axiosInstance.post(`/achievement-panel`, achievement);
        });
      }
      if (socials?.length) {
        socials = updateFieldForObjects(socials, "user", add?.data?.data?.id);
        socials?.map(async (social) => {
          await axiosInstance.post(`/social-panel`, social);
        });
      }
      if (metaData?.length) {
        metaData = updateFieldForObjects(
          metaData,
          "entity",
          add?.data?.data?.id
        );
        metaData?.map(async (metaDataa) => {
          await axiosInstance.post(`/metaData-panel`, metaDataa);
        });
      }
    }

    dispath(updateFields({ prop: "load", value: false }));
    cb();
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));

    handleErrors(e);
  }
};

export const createAndDownload = (path, data, cb) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));
    const resualt = await axiosInstance.post(path.baseRoute, data, {
      responseType: "blob",
    });
    dispath(updateFields({ prop: "load", value: false }));
    const blob = new Blob([resualt.data]);
    saveAs(blob, "report_" + Date.now().toString() + ".xlsx");
    cb();
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));
    e.response.data = JSON.parse(await e.response.data.text());
    handleErrors(e);
  }
};

export const dowloadEexelReport = (path, filters = {}, ex = ".xlsx") => async (
  dispath,
  getState
) => {
  try {
    let url = `${path.baseRoute}?pagination=false&download_excel=1`;

    // handle filters
    if (filters) {
      Object.keys(filters).map((item, index) => {
        if (filters[item]) {
          url = appendQueryParam(url, item, filters[item]);
        }
      });
    }
    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([resualt.data]);

    saveAs(blob, "report_list_" + Date.now().toString() + ex);
  } catch (e) {
    handleErrors(e);
  }
};
export const dowloadFile = (url) => async (dispath) => {
  try {
    const resualt = await axiosInstance.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([resualt.data]);
    saveAs(blob, "report_views" + Date.now().toString() + ".xlsx");
  } catch (e) {
    handleErrors(e);
  }
};

export const remove = (path, list, id, cb) => async (dispath) => {
  try {
    await axiosInstance.delete(`${path.baseRoute}/${id}`);
    cb();
  } catch (e) {
    handleErrors(e);
  }
};

export const getSingle = (path, id) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "single", value: null }));
    const result = await axiosInstance.get(`${path.baseRoute}/${id}`);
    dispath(updateFields({ prop: "single", value: result.data }));
    dispath(updateFields({ prop: "type", value: path.type }));
  } catch (e) {
    handleErrors(e);
  }
};

export const update = (path, id, data, cb) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));

    let achievements,
      deleteAchievements,
      socials,
      deleteSocials,
      metaData,
      deleteMetaData;

    if (data?.achievements) {
      achievements = data?.achievements;
      delete data?.achievements;
    }
    if (data?.deleteAchievements) {
      deleteAchievements = data?.deleteAchievements;
      delete data?.deleteAchievements;
    }

    if (data?.socials) {
      socials = data?.socials;
      delete data?.socials;
    }
    if (data?.deleteSocials) {
      deleteSocials = data?.deleteSocials;
      delete data?.deleteSocials;
    }

    if (data?.metaData) {
      metaData = data?.metaData;
      delete data?.metaData;
    }
    if (data?.deleteMetaData) {
      deleteMetaData = data?.deleteMetaData;
      delete data?.deleteMetaData;
    }

    const update = await axiosInstance.put(`${path.baseRoute}/${id}`, data);

    if (update && update?.data?.data) {
      if (achievements?.length) {
        achievements = updateFieldForObjects(
          achievements,
          "entity",
          update?.data?.data?.id,
          ["uuid", "createdAt", "updatedAt"]
        );

        await axiosInstance.put(`/achievement-panel/bulk`, achievements);
      }
      if (deleteAchievements?.length) {
        await axiosInstance.put(`/achievement-panel/bulk/delete`, {
          ids: deleteAchievements,
        });
      }

      if (socials?.length) {
        socials = updateFieldForObjects(
          socials,
          "user",
          update?.data?.data?.id,
          ["uuid", "createdAt", "updatedAt"]
        );
        await axiosInstance.put(`/social-panel/bulk`, socials);
      }
      if (deleteSocials?.length) {
        await axiosInstance.put(`/social-panel/bulk/delete`, {
          ids: deleteSocials,
        });
      }

      if (metaData?.length) {
        metaData = updateFieldForObjects(
          metaData,
          "entity",
          update?.data?.data?.id,
          ["uuid", "createdAt", "updatedAt"]
        );
        await axiosInstance.put(`/metaData-panel/bulk`, metaData);
      }
      if (deleteMetaData?.length) {
        await axiosInstance.put(`/metaData-panel/bulk/delete`, {
          ids: deleteMetaData,
        });
      }
    }

    dispath(updateFields({ prop: "load", value: false }));
    cb();
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));
    handleErrors(e);
  }
};

export const quickUpdate = (path, id, data, cb) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));
    await axiosInstance.patch(`${path.baseRoute}/${id}`, data);
    dispath(updateFields({ prop: "load", value: false }));
    cb();
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));
    handleErrors(e);
  }
};

export const quickUpdatePassword = (path, id, data, cb) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));
    await axiosInstance.put(`${path.baseRoute}/change-pass/${id}`, data);
    dispath(updateFields({ prop: "load", value: false }));
    cb();
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));
    handleErrors(e);
  }
};

// trash actions
export const restore = (path, list, id, cb) => async (dispath) => {
  try {
    await axiosInstance.put(`/core/trash/${path.model}/${id}`);

    const newList = list.filter((item) => item.id !== id);
    // if list is empty go to page one
    if (newList.length >= 0) {
      dispath(updateFields({ prop: "list", value: newList }));
    } else {
      cb();
    }
  } catch (e) {
    handleErrors(e);
  }
};

export const forceDelete = (path, list, id, cb) => async (dispath) => {
  try {
    await axiosInstance.delete(`/core/trash/${path.model}/${id}`);

    const newList = list.filter((item) => item.id !== id);
    // if list is empty go to page one
    if (newList.length >= 0) {
      dispath(updateFields({ prop: "list", value: newList }));
    } else {
      cb();
    }
  } catch (e) {
    handleErrors(e);
  }
};

// socket actions
export const syncDelete = (data) => (dispath, getState) => {
  try {
    const {
      unit: { list, type, load, hasQuery, page },
    } = getState();
    if (data.model == type && !load && !hasQuery && page == 1) {
      const newList = list.filter((item) => item.id != data.data.id);
      dispath(updateFields({ prop: "list", value: newList }));
    }
  } catch (e) {
    handleErrors(e);
  }
};

export const syncAdd = (data) => (dispath, getState) => {
  try {
    const {
      unit: { list, type, load, hasQuery, page },
    } = getState();
    if (data.model == type && !load && !hasQuery && page == 1) {
      let newList = list;
      if (newList.length >= perpage) {
        newList.pop();
      }
      newList = [data.data, ...newList];
      dispath(updateFields({ prop: "list", value: newList }));
    }
  } catch (e) {
    handleErrors(e);
  }
};

export const syncEdit = (data) => (dispath, getState) => {
  try {
    const {
      unit: { list, type, load, hasQuery, page },
    } = getState();

    if (data.model == type && !load && !hasQuery && page == 1) {
      let newList = list.filter((item) => item.id != data.data.id);
      if (newList.length >= perpage) {
        newList.pop();
      }
      newList = [data.data, ...newList];
      dispath(updateFields({ prop: "list", value: newList }));
    }
  } catch (e) {
    handleErrors(e);
  }
};
